import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPenStyle0 = cosmosIconCss;

const CosmosIconPen$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPen extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4e4beb201e3bc1ac26287f6d7eb4fcc7d72696da', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '77f048fd6b6c7e087fdeb97372e12e5a4d91f11c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4ce5d5bd87c0f7bdb9b8812a67d9a005ce33fd49', d: "M5.213 13.899 12.99 6.12l2.828 2.829-7.778 7.778-3.323 1.075a.5.5 0 0 1-.627-.639L5.213 13.9Zm13.081-8.132c.195.195.222.485.06.648L16.88 7.888 14.052 5.06l1.473-1.473c.162-.163.453-.137.648.059l2.121 2.12Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPenStyle0; }
}, [1, "cosmos-icon-pen", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pen"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pen":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPen$1);
            }
            break;
    } });
}

const CosmosIconPen = CosmosIconPen$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPen, defineCustomElement };
